import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

interface SkeletonListProps {
  count?: number;
}

export const SkeletonList: React.FC<SkeletonListProps> = ({ count = 10 }) => (
  <Box aria-label="Đang tải danh sách nhóm" aria-busy="true">
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} variant="rectangular" height={48} sx={{ mb: 1, borderRadius: 1 }} />
    ))}
  </Box>
);
